import BlocQr from 'components/blocQr/blocQr'
import ClosePopupBtn from 'components/buttons/closePopupBtn'
import { PExt } from 'components/myTags/myTags'
import CounterContext from 'contexts/counter'
import { useContext, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import { Colors } from 'styles/colors'
import './pdfReader.scss'
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
type PdfReaderProps = {
   file: string
   close: () => void
   drive?: boolean
   qrcode?: string
   initialPage?: number
}
export default function PdfReader(props: PdfReaderProps) {
   const { file, close, drive, qrcode, initialPage } = props
   const [numPages, setNumPages] = useState(0)
   const { setCounter, counterDefault } = useContext(CounterContext)
   const [pageNumber, setPageNumber] = useState(1)
   function onDocumentLoadSuccess({ numPages }: any) {
      if (initialPage) {
         setPageNumber(initialPage)
      } else {
         setPageNumber(1)
      }
      setNumPages(numPages)
   }
   function changePage(offset: any) {
      setPageNumber((prevPageNumber) => prevPageNumber + offset)
   }
   function previousPage() {
      setCounter(counterDefault)
      changePage(-1)
   }
   function nextPage() {
      setCounter(counterDefault)
      changePage(1)
   }
   return (
      <div id='pdfReader' className='flex column center'>
         <div style={{ width: 892, height: 1263 }}>
            <Document
               file={`${drive ? 'pdf/' + file + '.pdf' : process.env.PUBLIC_URL + '/pdf/' + file}`}
               onLoadSuccess={onDocumentLoadSuccess}
               onLoadError={(error) => console.log(error.message)}
               loading={'Chargement en cours'}
               error={<div>Impossible de charger le PDF</div>}
            >
               <Page
                  pageNumber={pageNumber}
                  scale={1}
                  width={892}
                  className='imgOfPDF'
                  // height={200}
               />
            </Document>
         </div>
         <div style={{ height: 150, width: '100%' }}>
            {numPages > 1 && (
               <div className='pdfControls flex center w100'>
                  <button type='button' disabled={pageNumber <= 1} onClick={previousPage}>
                     <p>❰</p>
                  </button>
                  <PExt fontSize='20px' color={Colors.gris1}>
                     &nbsp;&nbsp;&nbsp;Page {pageNumber || (numPages ? 1 : '--')} /{' '}
                     {numPages || '--'}&nbsp;&nbsp;&nbsp;
                  </PExt>
                  <button
                     type='button'
                     disabled={pageNumber >= numPages}
                     onClick={nextPage}
                     style={{ transform: 'rotate(180deg)' }}
                  >
                     <p>❰</p>
                  </button>

                  {!drive && (
                     <div style={{ position: 'absolute', right: '0' }}>
                        <ClosePopupBtn close={close} />
                     </div>
                  )}
               </div>
            )}
         </div>
         {qrcode && (
            <div className='w100 flex center'>
               <BlocQr txt={'Télécharger le guide pratique RH'} url={qrcode} color={Colors.gris1} />
            </div>
         )}
      </div>
   )
}
